// 主体信息
export function getMockSubjectInfo(params) {
  //pre
  // return {'loginuser': {'account': 'hua.huang', 'email': 'hua.huang@pre.abite.com', 'emp': {'avatar': null, 'brandMdCode': null, 'businessSubjectMdCode': 20000000001, 'businessTreeMdCode': 10000000003, 'businessTreeName': '库迪咖啡（北京）有限公司', 'createTime': '2022-04-16T06:55:00.593+00:00', 'deptCode': 'O10000002', 'deptMdCode': 10000000003, 'deptName': '技术体系', 'empCode': '2204160001', 'empMdCode': 10100000850, 'franchiseMdCode': null, 'id': 852, 'innerFlag': 1, 'mainFlag': null, 'merchantNo': null, 'name': '黄华', 'nickName': null, 'postList': [{'postMdCode': 10200000018, 'name': '员工', 'assignType': 1}], 'realName': '黄华', 'roleList': null, 'subjectName': null, 'subjectTypeList': null}, 'empList': [{'avatar': null, 'brandMdCode': null, 'businessSubjectMdCode': 20000000001, 'businessTreeMdCode': 10000000003, 'businessTreeName': '库迪咖啡（北京）有限公司', 'createTime': '2022-04-16T06:55:00.593+00:00', 'deptCode': 'O10000002', 'deptMdCode': 10000000003, 'deptName': '技术体系', 'empCode': '2204160001', 'empMdCode': 10100000850, 'franchiseMdCode': null, 'id': 852, 'innerFlag': 1, 'mainFlag': null, 'merchantNo': null, 'name': '黄华', 'nickName': null, 'postList': [{'postMdCode': 10200000018, 'name': '员工', 'assignType': 1}], 'realName': '黄华', 'roleList': null, 'subjectName': null, 'subjectTypeList': null}], 'expirationTime': '2023-03-14T09:51:30.763+00:00', 'lastActiveTime': '2023-03-07T09:51:30.820+00:00', 'mobile': '+8613920586754', 'sensitiveFieldList': [], 'token': 'token-2497771839761539072-KdgFGydKEDuafiLqyhiTYUeFJsSxGvinAxnj'}, 'subject': {'account': 'hua.huang', 'empMdCode': 10100000850, 'itemSelected': {'mValue': false}, 'mdCode': 200, 'name': '库迪咖啡（北京）有限公司', 'showRedDot': {'mValue': false}, 'subjectType': [999], 'subjectTypeSelected': {'mValue': 999}}, 'subjectShopListCount': 384, 'subjectShop': {'address': '北京市西城区陶然亭街道虎坊路北京前门建国饭店101', 'cityMdCode': 110100, 'cityName': '北京市', 'deptRelationMdCode': null, 'franchiseAgentMdCode': null, 'franchiseBusinessNodeType': null, 'franchiseMdCode': 20800010048, 'franchiseType': 2, 'itemSelected': {'mValue': false}, 'itemSelectedSubjectType': {'mValue': -1}, 'mdCode': 20300020785, 'name': '加盟cotti02', 'operationMode': 1, 'provinceName': '北京市', 'shopShowNo': 'JD2022091400002', 'shopStatus': 1, 'shopType': 301, 'showRedDot': {'mValue': false}, 'takeFoodMode': null}};
  //test
  return {
    'loginuser': {
      'account': 'yanxue.wang',
      'email': 'yanxue.wang@test1.abite.com',
      'emp': {
        'avatar': '',
        'brandMdCode': 20200000006,
        'businessSubjectMdCode': 20000002704,
        'businessTreeMdCode': 20800010398,
        'businessTreeName': '总部',
        'createTime': '2022-12-03T03:37:18.341+00:00',
        'deptCode': null,
        'deptMdCode': null,
        'deptName': null,
        'empCode': '10100001269',
        'empMdCode': 10100001269,
        'franchiseMdCode': 20800010398,
        'id': 12950,
        'innerFlag': 3,
        'mainFlag': 1,
        'merchantNo': 'FRA20221203001',
        'name': '王艳雪',
        'nickName': null,
        'postList': [{ 'postMdCode': 10200000051, 'name': 'Cotti店长', 'assignType': 1 }],
        'realName': null,
        'roleList': [{
          'createTime': '2022-09-27T04:01:31.015+00:00',
          'id': 2004,
          'isDefault': 1,
          'name': '副店长',
          'remark': '',
          'roleType': 1,
          'sensitiveFieldList': null,
        }, {
          'createTime': '2022-09-27T04:01:31.227+00:00',
          'id': 2005,
          'isDefault': 1,
          'name': '值班主管',
          'remark': '',
          'roleType': 1,
          'sensitiveFieldList': null,
        }, {
          'createTime': '2022-09-27T04:01:30.390+00:00',
          'id': 2001,
          'isDefault': 1,
          'name': '超级管理员',
          'remark': '',
          'roleType': 1,
          'sensitiveFieldList': null,
        }, {
          'createTime': '2022-09-27T04:01:30.612+00:00',
          'id': 2002,
          'isDefault': 1,
          'name': '经理',
          'remark': '',
          'roleType': 1,
          'sensitiveFieldList': null,
        }],
        'subjectName': '王艳雪',
        'subjectTypeList': [20],
      },
      'empList': [{
        'avatar': null,
        'brandMdCode': null,
        'businessSubjectMdCode': 20000000001,
        'businessTreeMdCode': 10000000012,
        'businessTreeName': '库迪咖啡（北京）有限公司',
        'createTime': '2022-12-01T06:40:00.683+00:00',
        'deptCode': 'O10000002',
        'deptMdCode': 10000000012,
        'deptName': '技术体系',
        'empCode': '2212010000',
        'empMdCode': 10100001265,
        'franchiseMdCode': null,
        'id': 12946,
        'innerFlag': 0,
        'mainFlag': null,
        'merchantNo': null,
        'name': '王艳雪',
        'nickName': null,
        'postList': [{ 'postMdCode': 10200000024, 'name': '员工', 'assignType': 1 }],
        'realName': '王艳雪',
        'roleList': null,
        'subjectName': null,
        'subjectTypeList': null,
      }, {
        'avatar': '',
        'brandMdCode': null,
        'businessSubjectMdCode': 20000002704,
        'businessTreeMdCode': 20800010398,
        'businessTreeName': '王艳雪',
        'createTime': '2022-12-03T03:37:18.341+00:00',
        'deptCode': null,
        'deptMdCode': null,
        'deptName': null,
        'empCode': '10100001269',
        'empMdCode': 10100001269,
        'franchiseMdCode': null,
        'id': 12950,
        'innerFlag': 3,
        'mainFlag': 1,
        'merchantNo': null,
        'name': '王艳雪',
        'nickName': null,
        'postList': [{ 'postMdCode': 10200000051, 'name': 'Cotti店长', 'assignType': 1 }],
        'realName': null,
        'roleList': null,
        'subjectName': null,
        'subjectTypeList': null,
      }, {
        'avatar': '',
        'brandMdCode': null,
        'businessSubjectMdCode': 20000002731,
        'businessTreeMdCode': 20300017749,
        'businessTreeName': '我是联营托管店1店',
        'createTime': '2023-02-14T04:38:20.451+00:00',
        'deptCode': null,
        'deptMdCode': null,
        'deptName': null,
        'empCode': '10100001593',
        'empMdCode': 10100001593,
        'franchiseMdCode': null,
        'id': 13246,
        'innerFlag': 3,
        'mainFlag': 0,
        'merchantNo': null,
        'name': '王2',
        'nickName': null,
        'postList': [{ 'postMdCode': 10200000053, 'name': 'Cotti咖啡师', 'assignType': 1 }],
        'realName': null,
        'roleList': null,
        'subjectName': null,
        'subjectTypeList': null,
      }, {
        'avatar': '',
        'brandMdCode': null,
        'businessSubjectMdCode': 20000002604,
        'businessTreeMdCode': 20300017452,
        'businessTreeName': '库迪凯里老财校店4',
        'createTime': '2022-12-27T04:00:27.177+00:00',
        'deptCode': null,
        'deptMdCode': null,
        'deptName': null,
        'empCode': '10100001320',
        'empMdCode': 10100001320,
        'franchiseMdCode': null,
        'id': 12998,
        'innerFlag': 3,
        'mainFlag': 0,
        'merchantNo': null,
        'name': '王艳雪',
        'nickName': null,
        'postList': [{ 'postMdCode': 10200000051, 'name': 'Cotti店长', 'assignType': 1 }],
        'realName': null,
        'roleList': null,
        'subjectName': null,
        'subjectTypeList': null,
      }],
      'expirationTime': '2023-03-11T03:51:49.741+00:00',
      'lastActiveTime': '2023-03-04T03:51:49.791+00:00',
      'mobile': '+8618746955752',
      'sensitiveFieldList': ['distributionPrice'],
      'token': 'token-7583111473692665856-GFNBXWqUVoOifLzSgFSkPMWOqMZOxRPxtIGj',
    },
    'subject': {
      'account': 'yanxue.wang',
      'empMdCode': 10100001269,
      'itemSelected': { 'mValue': true },
      'mdCode': 20000002704,
      'name': '王艳雪',
      'showRedDot': { 'mValue': true },
      'subjectType': [20],
      'subjectTypeSelected': { 'mValue': 20 },
    },
    'subjectShopListCount': 3,
    'subjectShop': {
      'address': '天津市辅仁路与一纬一支路交叉口东南40米22',
      'cityMdCode': 120100,
      'cityName': '天津市',
      'deptRelationMdCode': 10000002277,
      'franchiseAgentMdCode': 0,
      'franchiseBusinessNodeType': -1,
      'franchiseMdCode': 20800010398,
      'franchiseType': 2,
      'itemSelected': { 'mValue': false },
      'itemSelectedSubjectType': { 'mValue': -1 },
      'mdCode': 20300017740,
      'name': '王5的店需要店长店',
      'operationMode': 1,
      'provinceName': '天津市',
      'shopShowNo': 'JD2023021100003',
      'shopStatus': 1,
      'shopType': 302,
      'showRedDot': { 'mValue': false },
      'takeFoodMode': '',
    },
  };
}

export function getMockMenu() {
  return [
    {
      'alwaysShow': true,
      'component': 'Layout',
      'frameFlag': 1,
      'hidden': false,
      'id': 10027221,
      'meta':
        {
          'icon': '#',
          'noCache': true,
          'title': '首页',
        },
      'name': '首页',
      'orderNum': 0,
      'path': 'https://stationtest.us.cotticoffee.global/#/home',
      'perms': '',
      'redirect': 'noRedirect',
      'resourceType': 0,
    },
    {
      'alwaysShow': true,
      'children':
        [
          {
            'component': '#',
            'frameFlag': 0,
            'hidden': false,
            'id': 10027233,
            'meta':
              {
                'icon': '#',
                'noCache': true,
                'title': '库迪学院',
              },
            'name': '库迪学院',
            'orderNum': 2,
            'path': '#',
            'perms': 'franchise:cottichannelpartner-app:college',
            'resourceType': 1,
          },
          {
            'component': '#',
            'frameFlag': 0,
            'hidden': false,
            'id': 10027234,
            'meta':
              {
                'icon': '#',
                'noCache': true,
                'title': '意见反馈',
              },
            'name': '意见反馈',
            'orderNum': 3,
            'path': '#',
            'perms': 'franchise:cottichannelpartner-app:feedback',
            'resourceType': 1,
          },
          {
            'component': 'Layout',
            'frameFlag': 1,
            'hidden': false,
            'id': 10027619,
            'meta':
              {
                'icon': '#',
                'noCache': true,
                'title': '财务账户',
              },
            'name': '财务账户',
            'orderNum': 8,
            'path': 'https://partnerapptest.us.cotticoffee.global/#/financial/myAccount',
            'perms': 'franchise:partnerapp-operation:app-myAccount-Two',
            'resourceType': 1,
          },
          {
            'children':
              [
                {
                  'component': 'Layout',
                  'frameFlag': 1,
                  'hidden': false,
                  'id': 10027622,
                  'meta':
                    {
                      'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808378951448356.png',
                      'noCache': true,
                      'title': '银行卡',
                    },
                  'name': '银行卡',
                  'orderNum': 1,
                  'path': 'https://partnerapptest.us.cotticoffee.global/#/my/bankCard',
                  'perms': 'franchise:partnerapp-operation:my-bankCard-entrance',
                  'resourceType': 1,
                },
              ],
            'component': 'Layout',
            'frameFlag': 0,
            'hidden': false,
            'id': 10027621,
            'meta':
              {
                'icon': '#',
                'noCache': true,
                'title': '商户信息管理',
              },
            'name': '商户信息管理',
            'orderNum': 9,
            'path': '#',
            'perms': 'franchise:cottichannelpartner-app:merchantInformationManage',
            'resourceType': 1,
          },
        ],
      'component': 'Layout',
      'frameFlag': 1,
      'hidden': false,
      'id': 10027215,
      'meta':
        {
          'icon': '#',
          'noCache': true,
          'title': '行政管理',
        },
      'name': '行政管理',
      'orderNum': 1,
      'path': 'https://stationtest.us.cotticoffee.global/#/administration',
      'perms': '',
      'redirect': 'noRedirect',
      'resourceType': 0,
    },
    {
      'alwaysShow': true,
      'children':
        [
          {
            'alwaysShow': true,
            'children':
              [
                {
                  'alwaysShow': true,
                  'children':
                    [
                      {
                        'component': '#',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027308,
                        'meta':
                          {
                            'icon': '#',
                            'noCache': false,
                            'title': '数据概览',
                          },
                        'name': '数据概览',
                        'orderNum': 0,
                        'path': 'https://davincitest1.us.cotticoffee.global/share.html#share/dashboard?shareToken\\u003deNoNy8cRADEIBMGUJGAxT-HyD-nuOVU9JXYjiMzBMkUvkbojbo0eZfA72JkWrRcI_XVO-ybTPbekKvO_rRNGqn0IZ40ur7_UKLCq7KZnxLkN9oHJcGLfXx9VkB0e\\u0026isApp\\u003dtrue\\u0026loading\\u003dcotti',
                        'resourceType': 1,
                      },
                    ],
                  'component': 'Layout',
                  'frameFlag': 0,
                  'hidden': false,
                  'id': 10027307,
                  'meta':
                    {
                      'icon': '#',
                      'noCache': true,
                      'title': '运营看板',
                    },
                  'name': '运营看板',
                  'orderNum': 1,
                  'path': 'OperationKanban',
                  'redirect': 'noRedirect',
                  'resourceType': 0,
                },
              ],
            'component': 'Layout',
            'frameFlag': 0,
            'hidden': false,
            'id': 10027220,
            'meta':
              {
                'icon': '#',
                'noCache': true,
                'title': '数据',
              },
            'name': '数据',
            'orderNum': 0,
            'path': 'data',
            'redirect': 'noRedirect',
            'resourceType': 0,
          },
          {
            'component': 'Layout',
            'frameFlag': 1,
            'hidden': false,
            'id': 10027572,
            'meta':
              {
                'icon': '#',
                'noCache': true,
                'title': '建店',
              },
            'name': '建店',
            'orderNum': 1,
            'path': 'https://partnerapptest.us.cotticoffee.global/#/build-store/home',
            'perms': 'franchise:partnerapp-operation:build-store:home',
            'resourceType': 1,
          },
          {
            'alwaysShow': true,
            'children':
              [
                {
                  'alwaysShow': true,
                  'children':
                    [
                      {
                        'children':
                          [
                            {
                              'alwaysShow': true,
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027252,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '商品管理',
                                },
                              'name': '商品管理',
                              'orderNum': 1,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/goodsList/#',
                              'perms': '',
                              'redirect': 'noRedirect',
                              'resourceType': 0,
                            },
                          ],
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027219,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808397775948733.png',
                            'noCache': true,
                            'title': '商品',
                          },
                        'name': '商品',
                        'orderNum': 1,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/goodsList',
                        'perms': 'franchise:partnerapp-operation:cotticoffee-app-goods-list',
                        'resourceType': 1,
                      },
                      {
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027243,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808397908199823.png',
                            'noCache': true,
                            'title': '门店',
                          },
                        'name': '门店',
                        'orderNum': 3,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/shopsDetail',
                        'perms': 'franchise:partnerapp-operation:cotticoffee-app-shops-detail',
                        'resourceType': 1,
                      },
                      {
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': true,
                        'id': 10027246,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808398308913485.png',
                            'noCache': true,
                            'title': '手工发券',
                          },
                        'name': '手工发券',
                        'orderNum': 6,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/coupon/couponSend',
                        'perms': 'franchise:partnerapp-operation:cotticoffee-app-attendance-coupon',
                        'resourceType': 1,
                      },
                      {
                        'children':
                          [
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027259,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '费用管理编辑',
                                },
                              'name': '费用管理编辑',
                              'orderNum': 1,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/feeList/feeEdit',
                              'perms': '',
                              'resourceType': 1,
                            },
                          ],
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027247,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808398430191637.png',
                            'noCache': true,
                            'title': '费用',
                          },
                        'name': '费用',
                        'orderNum': 7,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/feeList',
                        'perms': 'franchise:partnerapp-operation:cotticoffee-app-attendance-fee',
                        'resourceType': 1,
                      },
                    ],
                  'component': 'Layout',
                  'frameFlag': 1,
                  'hidden': false,
                  'id': 10027218,
                  'meta':
                    {
                      'icon': '#',
                      'noCache': true,
                      'title': '经营管理',
                    },
                  'name': '经营管理',
                  'orderNum': 1,
                  'path': 'https://partnerapptest.us.cotticoffee.global/#/',
                  'perms': '',
                  'redirect': 'noRedirect',
                  'resourceType': 0,
                },
                {
                  'alwaysShow': true,
                  'children':
                    [
                      {
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027242,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808397548807038.png',
                            'noCache': true,
                            'title': '员工',
                          },
                        'name': '员工',
                        'orderNum': 0,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/employee/list',
                        'perms': 'franchise:partnerapp-operation:cotticoffee-app-employee-list',
                        'resourceType': 1,
                      },
                      {
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027245,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808398156539982.png',
                            'noCache': true,
                            'title': '排班',
                          },
                        'name': '排班',
                        'orderNum': 1,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/attendance/scheduling',
                        'perms': 'franchise:partnerapp-operation:cotticoffee-app-attendance-scheduling',
                        'resourceType': 1,
                      },
                      {
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027244,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808398014309437.png',
                            'noCache': true,
                            'title': '考勤日历',
                          },
                        'name': '考勤日历',
                        'orderNum': 2,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/attendance/calendar',
                        'perms': 'franchise:partnerapp-operation:cotticoffee-app-attendance-calendar',
                        'resourceType': 1,
                      },
                    ],
                  'component': 'Layout',
                  'frameFlag': 1,
                  'hidden': false,
                  'id': 10027630,
                  'meta':
                    {
                      'icon': '#',
                      'noCache': true,
                      'title': '门店员工',
                    },
                  'name': '门店员工',
                  'orderNum': 3,
                  'path': 'https://partnerapptest.us.cotticoffee.global/#/',
                  'perms': '',
                  'redirect': 'noRedirect',
                  'resourceType': 0,
                },
                {
                  'alwaysShow': true,
                  'children':
                    [
                      {
                        'children':
                          [
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027266,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '查看付款单',
                                },
                              'name': '查看付款单',
                              'orderNum': 7,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/orderStock/orderPayment',
                              'perms': 'franchise:partnerapp-operation:orderPayment',
                              'resourceType': 1,
                            },
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027267,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '查看结算单',
                                },
                              'name': '查看结算单',
                              'orderNum': 8,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/orderStock/orderSettlement',
                              'perms': 'franchise:partnerapp-operation:orderSettlement',
                              'resourceType': 1,
                            },
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027268,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '查看退款单',
                                },
                              'name': '查看退款单',
                              'orderNum': 9,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/orderStock/orderRefund',
                              'perms': 'franchise:partnerapp-operation:orderRefund',
                              'resourceType': 1,
                            },
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027269,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '操作记录',
                                },
                              'name': '操作记录',
                              'orderNum': 10,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/orderStock/orderLog',
                              'perms': 'franchise:partnerapp-operation:orderLog',
                              'resourceType': 1,
                            },
                          ],
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027241,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808395651591520.png',
                            'noCache': true,
                            'title': '订货单',
                          },
                        'name': '订货单',
                        'orderNum': 0,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/orderStock',
                        'perms': 'franchise:partnerapp-operation:orderStock',
                        'resourceType': 1,
                      },
                      {
                        'children':
                          [
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027272,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '配货单',
                                },
                              'name': '配货单',
                              'orderNum': 0,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/packing/#',
                              'perms': '',
                              'resourceType': 1,
                            },
                          ],
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027270,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808395864080537.png',
                            'noCache': true,
                            'title': '配货单',
                          },
                        'name': '配货单',
                        'orderNum': 1,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/packing',
                        'perms': 'franchise:partnerapp-operation:packing',
                        'resourceType': 1,
                      },
                      {
                        'children':
                          [
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027280,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '配货差异单',
                                },
                              'name': '配货差异单',
                              'orderNum': 0,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/packing-diff/#',
                              'perms': '',
                              'resourceType': 1,
                            },
                          ],
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027271,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808396141111824.png',
                            'noCache': true,
                            'title': '配货差异',
                          },
                        'name': '配货差异',
                        'orderNum': 2,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/packing-diff',
                        'perms': 'franchise:partnerapp-operation:packing-diff',
                        'resourceType': 1,
                      },
                      {
                        'children':
                          [
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027283,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '库存查询',
                                },
                              'name': '库存查询',
                              'orderNum': 0,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/stock/search/#',
                              'perms': '',
                              'resourceType': 1,
                            },
                          ],
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027275,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808396269352874.png',
                            'noCache': true,
                            'title': '库存查询',
                          },
                        'name': '库存查询',
                        'orderNum': 3,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/stock/search',
                        'perms': 'franchise:partnerapp-operation:stock-search',
                        'resourceType': 1,
                      },
                      {
                        'children':
                          [
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027284,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '库存流水',
                                },
                              'name': '库存流水',
                              'orderNum': 4,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/stock/flow/#',
                              'perms': '',
                              'resourceType': 1,
                            },
                          ],
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027276,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808396423011843.png',
                            'noCache': true,
                            'title': '库存流水',
                          },
                        'name': '库存流水',
                        'orderNum': 4,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/stock/flow',
                        'perms': 'franchise:partnerapp-operation:stock-flow',
                        'resourceType': 1,
                      },
                      {
                        'children':
                          [
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027285,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '入库明细列表',
                                },
                              'name': '入库明细列表',
                              'orderNum': 0,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/stock/in/#',
                              'perms': '',
                              'resourceType': 1,
                            },
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027286,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '入库明细详情',
                                },
                              'name': '入库明细详情',
                              'orderNum': 1,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/stock/in/#',
                              'perms': '',
                              'resourceType': 1,
                            },
                          ],
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027277,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808396544352571.png',
                            'noCache': true,
                            'title': '入库明细',
                          },
                        'name': '入库明细',
                        'orderNum': 5,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/stock/in',
                        'perms': 'franchise:partnerapp-operation:stock-in',
                        'resourceType': 1,
                      },
                      {
                        'children':
                          [
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027287,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '出库明细列表',
                                },
                              'name': '出库明细列表',
                              'orderNum': 0,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/stock/out/#',
                              'perms': '',
                              'resourceType': 1,
                            },
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027288,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '出库明细详情',
                                },
                              'name': '出库明细详情',
                              'orderNum': 1,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/stock/out/#',
                              'perms': '',
                              'resourceType': 1,
                            },
                          ],
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027278,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808396644149930.png',
                            'noCache': true,
                            'title': '出库明细',
                          },
                        'name': '出库明细',
                        'orderNum': 6,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/stock/out',
                        'perms': 'franchise:partnerapp-operation:stock-out',
                        'resourceType': 1,
                      },
                      {
                        'children':
                          [
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027291,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '盘点列表页',
                                },
                              'name': '盘点列表页',
                              'orderNum': 0,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/inventory/#',
                              'perms': '',
                              'resourceType': 1,
                            },
                            {
                              'component': 'Layout',
                              'frameFlag': 1,
                              'hidden': false,
                              'id': 10027292,
                              'meta':
                                {
                                  'icon': '#',
                                  'noCache': true,
                                  'title': '盘点详情页',
                                },
                              'name': '盘点详情页',
                              'orderNum': 1,
                              'path': 'https://partnerapptest.us.cotticoffee.global/#/inventory/#',
                              'perms': '',
                              'resourceType': 1,
                            },
                          ],
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027279,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808396801991517.png',
                            'noCache': true,
                            'title': '盘点单',
                          },
                        'name': '盘点单',
                        'orderNum': 7,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/inventory',
                        'perms': 'franchise:partnerapp-operation:cotticoffee-app-inventory',
                        'resourceType': 1,
                      },
                      {
                        'component': 'Layout',
                        'frameFlag': 1,
                        'hidden': false,
                        'id': 10027455,
                        'meta':
                          {
                            'icon': 'https://yummy-mgt-dev.obs.cn-north-4.myhuaweicloud.com:443/mgtbase-backend/mgt/menuIcon/16808396928045479.png',
                            'noCache': true,
                            'title': '不合格品退货',
                          },
                        'name': '不合格品退货',
                        'orderNum': 8,
                        'path': 'https://partnerapptest.us.cotticoffee.global/#/returnStock',
                        'perms': 'franchise:partnerapp-operation:returnStock',
                        'resourceType': 1,
                      },
                    ],
                  'component': 'Layout',
                  'frameFlag': 1,
                  'hidden': false,
                  'id': 10027240,
                  'meta':
                    {
                      'icon': '#',
                      'noCache': true,
                      'title': '门店库存',
                    },
                  'name': '门店库存',
                  'orderNum': 4,
                  'path': 'https://partnerapptest.us.cotticoffee.global/#/',
                  'perms': '',
                  'redirect': 'noRedirect',
                  'resourceType': 0,
                },
              ],
            'component': 'Layout',
            'frameFlag': 1,
            'hidden': false,
            'id': 10027217,
            'meta':
              {
                'icon': '#',
                'noCache': true,
                'title': '经营',
              },
            'name': '经营',
            'orderNum': 2,
            'path': 'https://partnerapptest.us.cotticoffee.global/#/intention/entrance',
            'perms': '',
            'redirect': 'noRedirect',
            'resourceType': 0,
          },
        ],
      'component': 'Layout',
      'frameFlag': 0,
      'hidden': false,
      'id': 10027216,
      'meta':
        {
          'icon': '#',
          'noCache': true,
          'title': '业务管理',
        },
      'name': '业务管理',
      'orderNum': 2,
      'path': '/businessManagement',
      'redirect': 'noRedirect',
      'resourceType': 0,
    },
    {
      'alwaysShow': true,
      'component': 'Layout',
      'frameFlag': 1,
      'hidden': false,
      'id': 10027222,
      'meta':
        {
          'icon': '#',
          'noCache': true,
          'title': '消息',
        },
      'name': '消息',
      'orderNum': 3,
      'path': 'https://stationtest.us.cotticoffee.global/#/info',
      'perms': '',
      'redirect': 'noRedirect',
      'resourceType': 0,
    },
    {
      'alwaysShow': true,
      'component': 'Layout',
      'frameFlag': 1,
      'hidden': false,
      'id': 10027481,
      'meta':
        {
          'icon': '#',
          'noCache': true,
          'title': '通讯录',
        },
      'name': '通讯录',
      'orderNum': 4,
      'path': 'https://stationtest.us.cotticoffee.global/#/address-book',
      'perms': '',
      'redirect': 'noRedirect',
      'resourceType': 0,
    },
    {
      'alwaysShow': true,
      'children':
        [
          {
            'component': '#',
            'frameFlag': 0,
            'hidden': false,
            'id': 10027364,
            'meta':
              {
                'icon': '#',
                'noCache': true,
                'title': '人脸采集',
              },
            'name': '人脸采集',
            'orderNum': 1,
            'path': '#/face/collect/hide',
            'resourceType': 1,
          },
        ],
      'component': 'Layout',
      'frameFlag': 1,
      'hidden': false,
      'id': 10027223,
      'meta':
        {
          'icon': '#',
          'noCache': true,
          'title': '我的',
        },
      'name': '我的',
      'orderNum': 5,
      'path': 'https://stationtest.us.cotticoffee.global/#/#',
      'perms': '',
      'redirect': 'noRedirect',
      'resourceType': 0,
    },
  ];
}


